<template>
	<main class="main-wrapper flex-grow-1 " :class="listType != 'ListCategory' ? 'bg-documentGray':''">
		<template v-if="listType != 'ListCategory'" >
			<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m bg-white fix-header-title d-flex align-items-center justify-content-center">{{$t("2014")}}</div>
			<div class="divider"></div>
			<div class="subtabs ">
			<div class="mdc-tab-bar main-tabs" role="tablist">
				<div class="mdc-tab-scroller ">
					<div class="mdc-tab-scroller__scroll-area">
						<div class="mdc-tab-scroller__scroll-content justify-content-center">
							<button class="mdc-tab mdc-tab--active" role="tab" aria-selected="true" tabindex="0" @click="moveTab('ListTotal')"  @keypress="moveTab('ListTotal')">
								<span class="mdc-tab__content">
									<span class="mdc-tab__text-label font-m t-body2">{{$t('1889')}}</span>
								</span>
								<span class="mdc-tab-indicator mdc-tab-indicator--active">
									<span
										class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
								</span>
								<span class="mdc-tab__ripple"></span>
							</button>
							<button class="mdc-tab " role="tab" @click="moveTab('ListPopular')" @keypress="moveTab('ListPopular')" tabindex="0">
								<span class="mdc-tab__content">
									<span class="mdc-tab__text-label font-m t-body2">{{$t('866')}}</span>
								</span>
								<span class="mdc-tab-indicator ">
									<span
										class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
								</span>
								<span class="mdc-tab__ripple"></span>
							</button>
							<button class="mdc-tab " role="tab" @click="moveTab('ListNew')" @keypress="moveTab('ListNew')" tabindex="0">
								<span class="mdc-tab__content">
									<span class="mdc-tab__text-label font-m t-body2">{{$t('867')}}</span>
								</span>
								<span class="mdc-tab-indicator ">
									<span
										class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
								</span>
								<span class="mdc-tab__ripple"></span>
							</button>
							<button class="mdc-tab " role="tab"  @click="moveTab('ListRecommened')"  @keypress="moveTab('ListRecommened')" tabindex="0">
								<span class="mdc-tab__content">
									<span class="mdc-tab__text-label font-m t-body2">{{$t('868')}}</span>
								</span>
								<span class="mdc-tab-indicator ">
									<span
										class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
								</span>
								<span class="mdc-tab__ripple"></span>
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="divider divider-subtabs"></div>
		</div>
		</template>
		<transition>
			<component :is="listType" :listType="listType" ></component>
		</transition>
	</main>  
</template>

<script>
/**
 * 전체 차수 리스트 메인 컴포넌트(Total degree list main Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar} from '@material/tab-bar';
export default {
	components: {
		'ListTotal': () => import('./list/Total.vue'),
		'ListCategory': () => import('./list/Category.vue'),
		'ListPopular': () => import('./list/NewPopular.vue'),
		'ListNew': () => import('./list/NewPopular.vue'),
		'ListRecommened': () => import('./list/NewPopular.vue'),
	},

	data() {
		return {
			listType: 'ListTotal',
			tabBar: null
		}
	},
	watch:{
		'$route'(){
			this.listType = this.$route.query.type;
			this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'))
			this.setTabActive()
		}
	},
	mounted() {
		// 기본 파라미터 설정(set basic parameter)
		if (!this.$route.query.type) {
			this.$router.push('degree?type=ListTotal')
		}else{
			this.listType = this.$route.query.type;
		}
		this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'))
		this.setTabActive()
	},

	methods: {
		setTabActive() {
			let type = this.$route.query.type
			if (type === 'ListTotal' || type === 'ListCategory') {
				this.tabBar.activateTab(0)
			}else if (type == 'ListPopular') {
				this.tabBar.activateTab(1)
			}else if (type == 'ListNew') {
				this.tabBar.activateTab(2)
			}else if (type == 'ListRecommened') {
				this.tabBar.activateTab(3)
			}
		},
		setMaterialUi() {

			const selector = '.mdc-button, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			const buttonRipple = [].map.call(document.querySelectorAll(selector), function (el) {
				mdc.ripple.MDCRipple.attachTo(el);
			})


		},
		// 탭 이동(move tab)
		moveTab(type) {
			this.listType = type;
			this.$router.push('degree?type='+type)
			//this.$router.push({name: 'Degree', query: {type: type}})
		}
		
	}
}
</script>